import { PartialType } from '../../../../utils';
import { CreateVehicleModelFeeDto } from '../create';
export class UpdateVehicleModelFeeDto extends PartialType(CreateVehicleModelFeeDto) {
}
